//#
// TwgMap
// Creates a google map at the given container and places a marker at the
// current location
//#

class TwgMap {
  //#
  // Constructor
  // param {jquery element} - The element to insert the map into
  // param {Array} - array of kmz file urls
  constructor($mapContainer, kmlLayers) {
    // These can be overriden in any superclasses
    if (kmlLayers == null) {
      kmlLayers = [];
    }
    const { default_latitude } = window;
    const { default_longitude } = window;
    //default to a project asset or Chicago (look in project model and asset controller)
    if (!this.centerLocation) {
      this.centerLocation = { lat: default_latitude, lng: default_longitude };
    }
    if (!this.defaultZoom) {
      this.defaultZoom = 14;
    }

    // Create the Google Map
    this.$mapContainer = $mapContainer;
    this.map = new google.maps.Map(this.$mapContainer[0], {
      center: this.centerLocation,
      zoom: this.defaultZoom,
      streetViewControl: true,
    });

    // Create a small blue marker to represent the current location
    this.currentPositionMarker = new google.maps.Marker({
      position: this.centerLocation,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 15,
        fillColor: '#3BC4E2',
        strokeColor: '#3BC4E2',
        fillOpacity: 0.3,
        strokeWeight: 5,
      },
      zIndex: -99, // Needs to be -99 to appear below other markers
      map: this.map,
    });

    // Start listening to changes in geolocation
    this.startGeolocationListener();

    // Draw kml / kmz layers
    for (var url of kmlLayers) {
      new google.maps.KmlLayer({
        url,
        map: this.map,
        clickable: false,
        preserveViewport: true,
      });
    }
  }

  //#
  // Sets the location that the map will snap back to when the center button
  // is pressed
  // Param {float} - The latitude
  // Param {float} - The longitude
  setCenterLocation(latitude, longitude) {
    this.centerLocation = {
      lat: latitude,
      lng: longitude,
    };
    return this.refreshCurrentPositionMarker();
  }

  //#
  // Sets the location that the map will snap back to when the center button
  // is pressed
  // Param {obj} - The position object returned from
  // navigator.geolocation.getPosition
  setCenterFromLocation(position) {
    return this.setCenterLocation(
      position.coords.latitude,
      position.coords.longitude,
    );
  }

  //-----------  Private  -----------#
  //

  //#
  // Locks or unlocks the map (ie, dragging and zooming)
  // Param {bool} - true to lock the map, false to unlock
  setMapLock(lock) {
    this.mapLocked = lock;
    return this.map.setOptions({
      draggable: !lock,
      scrollwheel: !lock,
      disableDoubleClickZoom: lock,
    });
  }

  // Starts watching the geolocation.  Successful calls will trigger the
  // center marker to be repositioned
  startGeolocationListener(centerOnLocation) {
    if (centerOnLocation == null) {
      centerOnLocation = false;
    }
    const options = { enableHighAccuracy: true };

    const updateFunc = (position) => {
      this.setCenterFromLocation(position);
      if (centerOnLocation) {
        return this.map.setCenter(this.centerLocation);
      }
    };

    if (this.navigatorWatchId) {
      navigator.geolocation.clearWatch(this.navigatorWatchId);
    }

    return (this.navigatorWatchId = navigator.geolocation.watchPosition(
      updateFunc,
      this.warnGeolocationError,
      options,
    ));
  }

  // Moves the currentPositionMarker to the centerLocation
  refreshCurrentPositionMarker() {
    return this.currentPositionMarker.setPosition(this.centerLocation);
  }

  warnGeolocationError(error) {
    return console.warn(
      'Geolocation error (' + error.code + '): ' + error.message,
    );
  }
}

//-----------  Export  -----------#
module.exports = TwgMap;
